import Backdrop from "../Backdrop/Backdrop";
import "./Loader.css";

const Loader = () => {
  return (
    <>
      <div
        className="loader fixed z-50 top-0 mx-auto"
        style={{ marginTop: "35vh", marginLeft: "50%" }}
      />
      <Backdrop />
    </>
  );
};

export default Loader;
